module.exports = __webpack_public_path__ + "img/beaver-image.ca642ef5.jpg";